<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <swiper :options="swiperOption"
                  ref="mySwiper"
                  v-if="homeRotation && homeRotation.length > 0">
            <swiper-slide v-for="(item, index) in homeRotation"
                          :key="index">
              <img :src="item.resUrl"
                   style=" cursor: pointer;"
                   width="930"
                   height="380"
                   @click="Towindowurl(item.url)" />
            </swiper-slide>
            <div class="swiper-pagination"
                 slot="pagination"></div>
          </swiper>
        </div>
        <div class="bannerright display_column display_between">
          <!-- <img src="/image/index/topshuiyi.png" />
                    <img src="/image/index/topshuiyi2.png" /> -->
          <img v-for="(item, index) in topRotation"
               :key="index + '1'"
               :src="item.resUrl"
               @click="Towindowurl(item.url)"
               width="296"
               height="183"
               style="border-radius:10px; cursor: pointer;" />
          <img v-for="(item, index) in botRotation"
               :key="index + '2'"
               :src="item.resUrl"
               @click="Towindowurl(item.url)"
               width="296"
               height="183"
               style="border-radius:10px; cursor: pointer;box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);" />
        </div>
      </div>
    </div>
    <div class="topbox EC_width display_between">
      <div class="tbleft">
        <!-- <img src="/image/index/meetingtl.png"
             style="height:188px"
             alt=""> -->
        <img :src="t2lRotation[0].resUrl"
             style="height:188px"
             v-if="t2lRotation != null && t2lRotation.length > 0"
             alt="" />
        <div class="tbb">
          <p class="tbbtitle">品牌会议</p>
          <p class="tbbcount">全程数字化智能服务</p>
          <div class="tbbbtn"
               @click="Towindowurl(t2lRotation[0].url)">
            <span>查看更多</span>
          </div>
        </div>
      </div>
      <div class="tbright">
        <!-- <img src="/image/index/meetingtr.png"
             style="height:188px"
             alt=""> -->
        <img :src="t2rRotation[0].resUrl"
             style="height:188px"
             v-if="t2rRotation != null && t2rRotation.length > 0"
             alt="" />
        <div class="tbb">
          <p class="tbbtitle"
             style="color: #0B8586;">直播录播</p>
          <p class="tbbcount">智能服务 内外协同</p>
          <div class="tbbbtn"
               @click="Towindowurl(t2rRotation[0].url)">
            <span>查看更多</span>
          </div>
        </div>
      </div>
    </div>
    <div class="top1 EC_width">
      <div class="t1left">
        <div class="t1lt">
          <div class="gl_title_bar marginBottom20">
            <div class="gl_tb_left">
              <span class="normaltitle">高级研修班</span>
            </div>
            <div class="gl_tb_right">
              <a href="javascript:;"
                 class="gl_tb_right_more"
                 @click="onMore(212, '高级研修班')">
                <img src="/image/index/moreimg.png"
                     class="gltb_moreimg" />
                更多
              </a>
            </div>
          </div>
          <div class="t1ltbox">
            <div class="t1ltboxs"
                 :style="index == 2 ? 'margin-right:0' : ''"
                 v-for="(item, index) in topList"
                 @click="clkNews(item, '高级研修班')"
                 :key="index">
              <!-- <img :src="item.mtg_Image_ResUrl"
                   class="t1ltimg"
                   alt=""> -->
              <el-image class="t1ltimg"
                        :src="item.slideShow">
                <div slot="placeholder"
                     class="image-slot">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
              <!-- <div class="t1ltbq"
                   :style="getIsBm(item.mtg_Req_EndTime)?'background: #E71518;':''">
                <span v-show="getIsBm(item.mtg_Req_EndTime)">报名中</span>
                <span v-show="!getIsBm(item.mtg_Req_EndTime)">已结束</span>
              </div> -->
              <span class="t1ltbtitle"
                    style="text-indent: 0em;">{{ item.title }}</span>
            </div>
            <div class="t1ltboxno"
                 v-if="topList == null || topList.length == 0">
              <span>暂无资讯</span>
            </div>
          </div>
        </div>
        <div class="t1lb">
          <div class="gl_title_bar marginBottom20">
            <div class="gl_tb_left">
              <span class="tagTitle"
                    :class="{ tagTitleActive: tagIndex == item.id }"
                    v-for="(item, index) in meetingtype"
                    :key="index"
                    @click="tag(item.id)">
                {{ item.valueText }}
              </span>
            </div>
            <div class="gl_tb_right">
              <a href="javascript:;"
                 @click="toMeetingList(tagIndex)"
                 class="gl_tb_right_more">
                <img src="/image/index/moreimg.png"
                     class="gltb_moreimg" />
                更多
              </a>
            </div>
          </div>
          <div class="t1ltbox">
            <div class="t1ltboxs"
                 v-for="(item, index) in meetinglist"
                 :style="index == 2 ? 'margin-right:0' : ''"
                 @click="toMeeting(item.id)"
                 :key="index">
              <el-image class="t1ltimg"
                        :src="item.mtg_Image_ResUrl">
                <div slot="placeholder"
                     class="image-slot">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
              <div class="t1ltbq"
                   :style="getIsBm(item.mtg_Req_EndTime) ? 'background: #E71518;' : ''">
                <span v-show="getIsBm(item.mtg_Req_EndTime)">报名中</span>
                <span v-show="!getIsBm(item.mtg_Req_EndTime)">已结束</span>
              </div>
              <span class="t1ltbtitle">{{ item.mtg_Name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="t1right">
        <div class="gl_title_bar marginBottom20">
          <div class="gl_tb_left">
            <span class="normaltitle">学术日历</span>
          </div>
        </div>
        <div class="t1rt1 display_between">
          <!-- <img src="../../assets/img/icon/sanjiao3.png"
               alt=""> -->
          <img src="../../assets/img/icon/sanjiao4.png"
               @click="toTopNian(1)"
               alt="" />
          <span>{{ topNian }}年</span>
          <img src="../../assets/img/icon/sanjiao1.png"
               v-show="topNian >= topNianA"
               alt="" />
          <img src="../../assets/img/icon/sanjiao2.png"
               v-show="topNian < topNianA"
               @click="toTopNian(2)"
               alt="" />
        </div>
        <div class="t1rt2">
          <table>
            <tr v-for="item in 2"
                :key="item">
              <td v-for="items in 6"
                  :class="topYue == 6 * (item - 1) + items ? 't1rt2Yue' : ''"
                  :key="items + 's'"
                  @click="toTopYue(6 * (item - 1) + items)"
                  :style="items == 6 ? 'margin-right:0' : ''">
                {{ 6 * (item - 1) + items }}月
              </td>
            </tr>
          </table>
        </div>
        <div class="t1rt3">
          <img src="../../assets/img/icon/sanjiao5.png"
               v-show="IsT1r != 2 && t2rMeetingList.length > 2"
               @click="toBotT1r()"
               class="t1rt3btn"
               alt="" />
          <img src="../../assets/img/icon/sanjiao6.png"
               v-show="IsT1r == 2 && t2rMeetingList.length > 2"
               class="t1rt3btn"
               alt="" />
          <div class="t1rt3no"
               v-if="t2rMeetingList.length == 0">
            暂无内容
          </div>
          <div class="t1rt3box">
            <div class="t1rt3boxf"
                 id="t1rt3boxf">
              <div class="t1rt3boxs"
                   v-for="(item, index) in t2rMeetingList"
                   @click="toMeeting(item.id)"
                   :key="index">
                <!-- <img :src="item.mtg_Image_ResUrl"
                     alt=""> -->
                <el-image :src="item.mtg_Image_ResUrl"
                          style="width: 100%; height: 100%;">
                  <div slot="placeholder"
                       class="image-slot">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
              </div>
            </div>
          </div>
          <img src="../../assets/img/icon/sanjiao7.png"
               v-show="IsT1r != 1 && t2rMeetingList.length > 2"
               @click="toTopT1r()"
               class="t1rt3btn"
               alt="" />
          <img src="../../assets/img/icon/sanjiao8.png"
               v-show="IsT1r == 1"
               class="t1rt3btn"
               alt="" />
        </div>
      </div>
    </div>
    <div class="marginTop20 marginBottom50 EC_width"
         v-for="(item, index) in centreRotation"
         :key="index"
         @click="Towindowurl(item.url)">
      <img :src="item.resUrl"
           style="width:1240px" />
    </div>
    <div class="top2 EC_width">
      <div class="mainLeft">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">精品课件</span>
          </div>
        </div>
        <div class="tipsBanner marginTop20 display_column">
          <div class="flex1"></div>
          <div class="tips activeLine t2ltltle"
               v-for="(item, index) in courseList.slice(0, 1)"
               :key="index"
               @click="courseclick(item)">
            {{ item.title }}
          </div>
        </div>
        <div :style="index == 0 ? 'border:none;marginTop:0' : ''"
             class="border_top_18 marginTop20"
             v-for="(item, index) in courseList.slice(1, 4)"
             :key="index"
             @click="courseclick(item)">
          <div class="gl_title_vertical_line gl_title_v_line_active_gree activeLine t2ltltle">
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="mainCenter t2mid">
        <div class="gl_title_bar marginBottom20">
          <div class="gl_tb_left">
            <span class="normaltitle">学术动态</span>
          </div>
          <div class="gl_tb_right">
            <a href="javascript:;"
               class="gl_tb_right_more"
               @click="onMore(201, '学术动态')">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="gl_listWrapBar_nopad controlShow"
             v-for="(item, index) in academicList"
             :style="index == 0 ? 'margin-bottom:15px' : index == 1 ? 'margin-bottom:5px' : ''"
             :key="index">
          <div class="gl_imgList setShow"
               style="cursor: pointer;"
               v-if="index == 0 || index == 1"
               @click="clkNews(item, '学术动态')">
            <img :src="item.slideShow"
                 width="156px"
                 height="88px;" />
          </div>
          <a href="javascript:;"
             class="gl_listItem display_column_between">
            <div class="gl_listItemTitle  fontBold setShow"
                 v-show="index == 0 || index == 1"
                 style="margin-bottom: 9px;"
                 @click="clkNews(item, '学术动态')">
              {{ item.title }}
            </div>
            <div class="gl_listItemTitle disShow"
                 v-show="index != 0 && index != 1"
                 style="margin-bottom: 7.2px;"
                 @click="clkNews(item, '学术动态')">
              {{ ellipsis(item.title, 38) }}
            </div>
            <div class="display_between marginTop10 setShow"
                 v-show="index == 0 || index == 1">
              <div></div>
              <div class="gl_inforshow">
                <span class="marginRight20"> {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}</span>
                <span>
                  <img src="/image/index/chakan.png" />
                  {{ item.clickVolume }}
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="mainRight m2right">
        <div class="gl_title_bar marginBottom20">
          <div class="gl_tb_left">
            <span class="normaltitle">会议回放</span>
          </div>
        </div>
        <div class="t1rt3"
             style="height:553px">
          <img src="../../assets/img/icon/sanjiao5.png"
               v-show="IsT1r2 != 2 && meetdirectList.length > 2"
               @click="toBotT1r2()"
               class="t1rt3btn"
               alt="" />
          <img src="../../assets/img/icon/sanjiao6.png"
               v-show="IsT1r2 == 2 && meetdirectList.length > 2"
               class="t1rt3btn"
               alt="" />
          <div class="t1rt3box"
               style="height:485px">
            <div class="t1rt3boxf"
                 id="t1rt3boxf2">
              <div class="t1rt3boxs"
                   v-for="(item, index) in meetdirectList"
                   @click="clkNews(item, '会议回放')"
                   :key="index">
                <img :src="item.slideShow"
                     alt="" />
              </div>
            </div>
          </div>
          <img src="../../assets/img/icon/sanjiao7.png"
               v-show="IsT1r2 != 1 && meetdirectList.length > 2"
               @click="toTopT1r2()"
               class="t1rt3btn"
               alt="" />
          <img src="../../assets/img/icon/sanjiao8.png"
               v-show="IsT1r2 == 1"
               class="t1rt3btn"
               alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import format from '@/assets/unit/unit.js';
export default {
  name: 'meeting',
  data () {
    return {
      swiperOption: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        }
      },
      homeRotation: null, //轮播
      topRotation: null, //右上
      botRotation: null, //右下
      centreRotation: null, //中
      t2lRotation: null,
      t2rRotation: null,
      meetingtype: [],
      tagIndex: 0,
      meetinglist: [],
      t2rMeetingList: [],
      IsT1r: 2,
      IsT1r2: 2,
      academicList: [], //学术动态
      courseList: [], //课程列表
      topYue: 1,
      topList: [],
      meetdirectList: [],
      topNian: 2021,
      topNianA: 2021
    };
  },
  created () {
    var myDate = new Date();
    this.topNian = myDate.getFullYear();
    this.topNianA = myDate.getFullYear();
    var tMonth = myDate.getMonth();
    this.topYue = tMonth + 1;
    this.GetRotationInfo();
    this.getMeetingType();
    this.getInfoList();
    this.GetCourseVideoList();
  },
  mounted () {
    this.getIsT1r();
    this.getIsT1r2();
  },
  methods: {
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /** 获取轮播数据*/
    GetRotationInfo () {
      let _this = this;
      let arr = [20, 21, 22, 23, 28, 29];
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 2
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 20) _this.homeRotation = res.data.data || null;
              else if (arr[i] == 21) _this.topRotation = res.data.data || null;
              else if (arr[i] == 22) _this.botRotation = res.data.data || null;
              else if (arr[i] == 23) _this.centreRotation = res.data.data || null;
              else if (arr[i] == 28) _this.t2lRotation = res.data.data || null;
              else if (arr[i] == 29) _this.t2rRotation = res.data.data || null;
            }
          });
      }
    },
    getMeetingType () {
      this.httphelper.get('/api/BasicsmesApi/GetCodeResultList?type=4').then(res => {
        if (res.code == 200) {
          this.meetingtype = res.data;
          this.tagIndex = res.data[0].id;
          this.getMeetingListBytypeid();
          this.GetMeetingList();
        }
      });
    },
    tag (index) {
      this.tagIndex = index;
      this.getMeetingListBytypeid();
    },
    getIsBm (time) {
      let time1 = new Date(time).getTime();
      let time2 = new Date().getTime();
      if (time1 > time2) return true;
      else return false;
    },
    Towindowurl (url) {
      let urlstr = url;
      let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
      if (urlstr.search('grasshealList/grasshealListdetail') > -1) {
        const { href } = this.$router.resolve({
          path: '/home/inforDetails?' + param
        });
        window.open(href, '_blank');
      } else if (url != null && url != '') {
        window.open(url);
      }
    },
    getMeetingListBytypeid () {
      this.httphelper
        .post('/api/MeetingApi/GetMeetingList', {
          mtgType: this.tagIndex
        })
        .then(res => {
          if (res.data.code == 200) {
            this.meetinglist = [];
            if (res.data.data.startlist.length > 0) this.meetinglist = res.data.data.startlist;
            if (res.data.data.endlist.length > 0) this.meetinglist = this.meetinglist.concat(res.data.data.endlist);
            if (this.meetinglist.length > 0) {
              this.meetinglist = this.meetinglist.sort(function (a, b) {
                return new Date(b.mtg_StartTime).valueOf() - new Date(a.mtg_StartTime).valueOf();
              });
              this.meetinglist = this.meetinglist.splice(0, 6);
            }
          }
        });
    },
    GetMeetingList () {
      this.httphelper
        .post('/api/MeetingApi/GetMeetingPageList', {
          metName: '',
          sortType: 1,
          mtgType: 0,
          year: Number(this.topNian),
          month: Number(this.topYue),
          page: 1,
          limit: 10
        })
        .then(res => {
          if (res.data.code == 200) {
            this.t2rMeetingList = res.data.data;
            this.getIsT1r();
          }
          console.log(this.t2rMeetingList, 't2rMeetingList')
        });
    },
    toTopT1r () {
      this.$nextTick(() => {
        let dom = document.getElementById('t1rt3boxf');
        let i = 0;
        let test = setInterval(() => {
          let top = dom.style.top.replace(/px/g, '');
          if (i < 10) {
            dom.style.top = top - 18.8 + 'px';
            i++;
          } else {
            this.getIsT1r();
            clearInterval(test);
          }
        }, 15 - i);
      });
    },
    toBotT1r () {
      this.$nextTick(() => {
        let dom = document.getElementById('t1rt3boxf');
        let i = 0;
        let test = setInterval(() => {
          let top = dom.style.top.replace(/px/g, '').replace(/-/g, '');
          if (i < 10) {
            dom.style.top = -(top - 18.8) + 'px';
            i++;
          } else {
            this.getIsT1r();
            clearInterval(test);
          }
        }, 15 - i);
      });
    },
    getIsT1r () {
      let dom = document.getElementById('t1rt3boxf');
      if (dom != null) {
        let tops = dom.style.top.replace(/px/g, '').replace(/-/g, '');
        if (this.t2rMeetingList.length < 3) return (this.IsT1r = 2);
        if (tops >= (this.t2rMeetingList.length - 2) * 188) this.IsT1r = 1;
        else if (tops == 0) this.IsT1r = 2;
        else this.IsT1r = 0;
      }
    },
    toTopT1r2 () {
      this.$nextTick(() => {
        let dom = document.getElementById('t1rt3boxf2');
        let i = 0;
        let test = setInterval(() => {
          let top = dom.style.top.replace(/px/g, '');
          if (i < 10) {
            dom.style.top = top - 18.8 + 'px';
            i++;
          } else {
            this.getIsT1r2();
            clearInterval(test);
          }
        }, 15 - i);
      });
    },
    toBotT1r2 () {
      this.$nextTick(() => {
        let dom = document.getElementById('t1rt3boxf2');
        let i = 0;
        let test = setInterval(() => {
          let top = dom.style.top.replace(/px/g, '').replace(/-/g, '');
          if (i < 10) {
            dom.style.top = -(top - 18.8) + 'px';
            i++;
          } else {
            this.getIsT1r2();
            clearInterval(test);
          }
        }, 15 - i);
      });
    },
    getIsT1r2 () {
      let dom = document.getElementById('t1rt3boxf2');
      if (dom != null) {
        let tops = dom.style.top.replace(/px/g, '').replace(/-/g, '');
        if (this.meetdirectList.length < 3) return (this.IsT1r2 = 2);
        if (tops >= (this.meetdirectList.length - 2) * 188) this.IsT1r2 = 1;
        else if (tops == 0) this.IsT1r2 = 2;
        else this.IsT1r2 = 0;
      }
    },
    /* 获取学术动态,精彩讲座 */
    getInfoList () {
      let arr = [201, 204, 212];
      for (let i = 0; i < arr.length; i++) {
        this.GetGpSiteNewInfoPageList(arr[i]);
      }
    },
    GetGpSiteNewInfoPageList (cType) {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetGpSiteNewInfoPageList', {
          keyword: '',
          id: 0,
          parentID: 0,
          column_Type: cType,
          pageIndex: 1,
          pageSize: 12
        })
        .then(res => {
          if (res.data.code == 200) {
            let gpSiteNewInfoViewsViews = res.data.data.gpSiteNewInfoViewsViews;
            if (gpSiteNewInfoViewsViews != null && gpSiteNewInfoViewsViews.length > 0) {
              if (cType == 201) _this.academicList = gpSiteNewInfoViewsViews;
              else if (cType == 204) {
                _this.meetdirectList = gpSiteNewInfoViewsViews;
                // this.getIsT1r2()
              } else if (cType == 212) _this.topList = gpSiteNewInfoViewsViews;
            }
          }
        });
    },
    GetCourseVideoList () {
      let _this = this;
      this.httphelper
        .post('/api/CGPInfoApi/GetGpCourseVideoInfoPageLists', {
          course_Type: 0,
          fuzzysearch: '',
          labelgather: '',
          orderBy: 1,
          pageIndex: 1,
          pageSize: 4,
          resinfoType: 4
        })
        .then(res => {
          _this.courseList = res.data.data.gpCourseVideoInfoViews;
        });
    },
    toTopYue (index) {
      this.topYue = index;
      this.GetMeetingList();
    },
    toTopNian (index) {
      if (index == 1) this.topNian--;
      else if (index == 2) this.topNian++;
      this.GetMeetingList();
    },
    /** 课程跳转*/
    courseclick (item) {
      let id = item.id;
      let url = this.httphelper.IsDebugCgphome() + '/detail?courseId=' + id;
      window.open(url);
    },
    /* 新闻的点击事件 */
    clkNews (info, meuntitle) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        var param = {
          pid: 40,
          title: meuntitle,
          cid: info.cid,
          goroutename: 'home/Inforlist'
        };
        localStorage.setItem('Inforlist_param_' + info.cid, JSON.stringify(param));
        const { href } = this.$router.resolve({
          path: '/home/Inforlist/inforDetails?',
          query: {
            id: info.id,
            column_Type: info.cid
          }
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address);
      }
    },
    onMore (cid, conetntitle) {
      this.$router.push({
        path: '/home/Inforlist',
        query: {
          pid: 40,
          title: conetntitle,
          cid: cid
        }
      });
    },
    toMeetingList (cid) {
      let title = '';
      for (let i = 0; i < this.meetingtype.length; i++) {
        if (this.meetingtype[i].id == cid) {
          title = this.meetingtype[i].valueText.replace(/\r\n/g, '');
          const { href } = this.$router.resolve({
            path: '/home/meetingList',
            query: {
              pid: 40,
              title: title,
              cid: cid
            }
          });
          window.open(href, '_blank');
        }
      }
    },
    toMeeting (id) {
      const { href } = this.$router.resolve({
        name: 'meetingpc',
        query: {
          mid: id
        }
      });
      window.open(href, '_blank');
    }
  }
};
</script>

<style scoped>
.content {
    flex: 1;
}

.bannerWrap {
    height: 450px;
    padding-top: 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #dbeded, #ffffff);
}

/* 上部banner */

.topbanner {
    height: 380px;
}

.bannerleft {
    width: 930px;
    height: 380px;
    background: #005660;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    /* border-radius: 20px 0px 0px 0px; */
    border-radius: 10px;
    overflow: hidden;
}

.bannerright {
    width: 299px;
    height: 380px;
    /* box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15); */
    border-radius: 0px 0px 20px 0px;
}

.main {
    padding: 50px 0;
}

.sign {
    width: 67px;
    padding: 0 10px;
    height: 24px;
    background: #e71518;
    border-radius: 12px;
    color: #fff;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    margin-right: 2px;
}

/* 首页文字轮播 */
.bulletWrite {
    margin-right: 6px;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #6c9ca3;
    border-radius: 50%;
}

.bulletWriteActive {
    width: 24px;
    height: 10px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
}

.my-bullet-active {
    background: #ff6600;
    opacity: 1;
}

.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
}

.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 42%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

.swiper-slide {
    text-align: left;
}

.topbox {
    height: 188px;
    margin: 10px auto;
}

.tbleft {
    width: 610px;
    height: 188px;
    background: #e9ddd2;
    box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    display: flex;
}

.tbright {
    width: 610px;
    height: 188px;
    background: #d2e9e8;
    box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    display: flex;
}

.tbb {
    padding: 20px 25px;
}

.tbbtitle {
    line-height: 45px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ae0002;
}

.tbbcount {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
}

.tbbbtn {
    width: 100px;
    height: 34px;
    background: #ffffff;
    border-radius: 17px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #404040;
    line-height: 34px;
    text-align: center;
    margin-top: 48px;
    cursor: pointer;
}

.top1 {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
}

.t1left {
    width: 880px;
}

.t1right {
    width: 298px;
}

.t1rt1 {
    width: 298px;
    height: 34px;
    background: #0b8586;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 16px;
    margin-bottom: 10px;
}

.t1rt1 img {
    padding: 2px;
    cursor: pointer;
}

.t1rt2 {
    margin-bottom: 70px;
}

.t1rt2 table {
    border-collapse: collapse;
    border-spacing: 0;
}

.t1rt2 tr {
    display: flex;
    justify-content: space-between;
}

.t1rt2 td {
    width: 48px;
    height: 34px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    box-sizing: border-box;
    margin: 0 2px 2px 0;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
}

.t1rt2 td:hover {
    background: #e8f6f5;
}

.t1ltbox {
    /* display: flex; */
    display: grid;
    grid-template-columns: repeat(auto-fill, 280px);
    justify-content: space-between;
    margin-bottom: 40px;
}

.t1ltboxno {
    height: 235px;
    width: 100%;
    text-align: center;
    line-height: 100px;
}

.t1ltboxs {
    width: 280px;
    height: 235px;
    overflow: hidden;
    position: relative;
    margin-right: 20px;
    cursor: pointer;
}

.t1ltboxs .t1ltimg {
    width: 280px;
    height: 165px;
    margin-bottom: 10px;
}

.t1ltboxs .t1ltbq {
    width: 67px;
    height: 24px;
    background: #c4c4c4;
    border-radius: 12px;
    margin-right: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    text-align: center;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 180px;
}

.t1ltboxs ::v-deep .image-slot {
    height: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
}

.t1rt3boxs ::v-deep .image-slot {
    width: 298px;
    height: 168px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
}

.t1ltbtitle {
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-indent: 4.8em;
}

.t1rt3 {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.t1rt3box {
    width: 298px;
    height: 564px;
    margin: 8px 0;
    overflow-y: hidden;
}

.t1rt3boxf {
    /* overflow-x: hidden; */
    /* overflow-y: auto; */
    position: relative;
    top: 0;
}

.t1rt3boxs {
    width: 298px;
    height: 168px;
    margin-bottom: 20px;
    cursor: pointer;
}

.t1rt3boxs img {
    width: 298px;
    height: 168px;
}

.t1rt3btn {
    padding: 2px;
    cursor: pointer;
}

.t1rt3no {
    text-align: center;
    line-height: 100px;
}

.top2 {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
}

.top2 .mainLeft {
    width: 200px;
}

.tipsBanner {
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 28px;
    padding-bottom: 23px;
    height: 310px;
    background: url(/image/index/huiyiTips.png) no-repeat;
    background-size: 100% 100%;
}

.tips {
    color: #fff;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
}

.activeLine {
    cursor: pointer;
}

.activeLine:hover {
    color: #0b8485;
}

.t2mid {
    width: 600px;
}

.t2ltltle {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.m2right {
    width: 298px;
}

/* .setShow {
    display: none;
} */
/* .controlShow:hover .setShow {
    display: flex;
} */
.controlShow .setShow {
    display: flex;
}

/* .controlShow:hover .disShow {
    display: none;
} */
.t1rt2 .t1rt2Yue {
    color: #fff;
    background-color: #0b8485;
    border-color: #0b8485;
    border-radius: 2px;
}

.t1rt2 .t1rt2Yue:hover {
    color: #fff;
    background-color: #0b8485;
    border-color: #0b8485;
}
</style>
